import React from 'react';
import Barchart from '../Barchart';
import SingleNumber from '../SingleNumber';
import ListKeyValue from '../ListKeyValue';
import './index.css';

export default class DataWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.showOnMapHandler = this.showOnMapHandler.bind(this);
    }
    showOnMapHandler() {
        const { showOnMapCallback } = this.props;
        if (showOnMapCallback) {
            showOnMapCallback();
        }
    }
    listItemHandler(checkStatus, selectedItem) {
        const { onListItemClick } = this.props;
        if (onListItemClick) {
            const dataToCallback = {};
            dataToCallback.checkStatus = checkStatus;
            dataToCallback.selectedItem = selectedItem;
            onListItemClick(dataToCallback);
        }
    }
    render() {
        const {
            dataObject, title, attributeName, type, unit,
            subAttributeLabelName, subAttributeValueName,
            showOnMapCallback,
            height,
            colorRange,
            keyName,
            valueName,
            isLoading,
            customFooterComponent,
        } = this.props;
        if (!dataObject) return null;

        let internalElement = null;
        if (type === 'single_number') {
            internalElement = (
                <SingleNumber
                    value={dataObject[attributeName]}
                    unit={unit}
                    showOnMapCallback={showOnMapCallback}
                />
            );
        } else if (type === 'bar_chart') {
            if (!dataObject[attributeName] || dataObject[attributeName].length <= 0) internalElement = null;
            internalElement = (
                <div>
                    <Barchart
                        rawDataArray={dataObject[attributeName]}
                        title={title}
                        attributeName={attributeName}
                        type={type}
                        unit={unit}
                        subAttributeLabelName={subAttributeLabelName}
                        subAttributeValueName={subAttributeValueName}
                        height={height}
                    />
                </div>
            );
        } else if (type === 'list_key_value') {
            internalElement = (
                <div className="site-planning__sidebar-data-widget__list">
                    <ListKeyValue
                        listOfData={dataObject[attributeName]}
                        keyName={keyName}
                        valueName={valueName}
                        listItemHandler={(eventValue, selectedRow) => this.listItemHandler(eventValue, selectedRow)}
                    />
                </div>
            );
        } else {
            internalElement = null;
        }
        return (
            <div className="site-planning__sidebar-data-widget-wrapper">
                <div className={`site-planning__sidebar-data-widget-is-loading-data ${isLoading ? 'xxxactive' : ''}`} />
                <div className="site-planning__sidebar-data-widget">
                    <div className="site-planning__sidebar-data-widget__title">
                        {title || attributeName}
                    </div>
                    {internalElement}
                    {customFooterComponent}
                </div>
            </div>
        );
    }
}